var styles = {
  "snowflake": "index-module_snowflake__r9M9H",
  "fall": "index-module_fall__7dFxG",
  "glow": "index-module_glow__-2g4v"
};
export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
